import type { Error } from '@swf/core/utils/validators';

const streetFormat = (value: string) =>
  (/[A-za-z]/.test(value) && /\d/.test(value) && /[\s\-.]/.test(value)) ||
  /general delivery|poste restante/.test(value);

export const address =
  (country: string, message: Error['message']) =>
  (value: string): Error => ({
    valid: !!value && ['CA', 'US'].indexOf(country) < 0 ? true : streetFormat(value),
    message
  });
